import React from "react";
import { getDiffClassName } from "./ValueChangeIndicatorUtils";
import { DataDisplayType } from "./ValueChangeIndicatorTypes";

interface DiffValueDisplayerProps {
  diffValue: number;
  diffValueDecimalPlaces?: number;
  dataDisplayType: DataDisplayType;
  useDiffIndicatorColors?: boolean;
  formattedValue: string;
  fontSize?: string;
  iconFontSize?: string;
}

const arrowUp =
  "M440-727 256-544l-56-56 280-280 280 280-56 57-184-184v287h-80v-287Zm0 487v-120h80v120h-80Zm0 160v-80h80v80h-80Z";
const arrowDown =
  "M480-80 200-360l56-57 184 184v-287h80v287l184-183 56 56L480-80Zm-40-520v-120h80v120h-80Zm0-200v-80h80v80h-80Z";
const arrowUpDown =
  "M480-120 320-280l56-56 64 63v-414l-64 63-56-56 160-160 160 160-56 57-64-64v414l64-63 56 56-160 160Z";

const DiffValueDisplayer = ({
  diffValue,
  diffValueDecimalPlaces = 2,
  dataDisplayType,
  useDiffIndicatorColors,
  formattedValue,
  fontSize,
  iconFontSize = "1em",
}: DiffValueDisplayerProps) => {
  const isNegative = diffValue < 0;
  const isNeutral = Number(diffValue.toFixed(diffValueDecimalPlaces)) === 0;
  const diffClass = isNegative ? "negative" : "positive";

  const getPath = () => {
    if (isNeutral) return arrowUpDown;
    if (isNegative) return arrowDown;
    return arrowUp;
  };

  return (
    <div
      style={{ fontSize, display: "flex", alignItems: "center", gap: "0.25em" }}
      className={getDiffClassName(isNeutral, dataDisplayType, useDiffIndicatorColors)}
    >
      <div className={diffClass}>{formattedValue}</div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        width={iconFontSize}
        height={iconFontSize}
        fill="currentColor"
        className={diffClass}
      >
        <path d={getPath()} />
      </svg>
    </div>
  );
};

export default DiffValueDisplayer;
